import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Progress, Switch, Tag } from 'antd';
import styled from 'styled-components';
import { StorageManager } from "datastake-daf/src/helpers/StorageManager";

import DynamicView from '../../../../../components/DynamicViewNew';
import { actions } from '../../../../../store/reducers/project';
import { useNavigate, useParams } from "react-router-dom";
import { getProgressColor } from "../../../../../helpers/Progress";
import moment from 'moment';
import NotFound from "../../../../../components/NotFound";
import PageHeader from "../../../../../components/Layout/PageHeader";

const Styles = styled.div`
	.ant-page-header {
		padding: 8px 8px 8px var(--size);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		.ant-page-header-heading {
			justify-content: flex-start;
		}
		.ant-page-header-heading-extra {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			flex-grow: 1;
			margin: 0 var(--size);
		}
		.ant-btn {
			display: flex;
			span[role="img"] {
				font-size: 18px;
			}
		}
	}
	.ant-descriptions {
		padding: var(--size)
	}
	.ant-descriptions:not(.project) {
		width: 100%;
		padding-bottom: 0;
		.ant-descriptions-title {
			font-size: 14px;
			font-weight: 500;
		}
		&:nth-of-type(1) {
			.ant-descriptions-title {
				opacity: 0;
			}
		}
	}
	.ant-descriptions-item {
		padding-bottom: 6px;
		.ant-descriptions-item-label {
			font-weight: 500
		}
	}
	.view-toggle {
		width: 80px;
	}
`;

const mstp = ({ authentication, forms, project }) => ({
  authentication,
  forms,
  project
});
function KYC({
  project: { kyc: formData = {}, retrieved },
  ProjectKYCGet
}) {
  const { t } = useTranslation();
  const { id, userId } = useParams();
  const goTo = useNavigate();
  const [isTabsView, setTabsView] = useState(StorageManager.get('datastake-view-mode') === 'section');
  const namespace = 'Stakeholder';
  const module = 'cadd';
  const view = 'kyc';
  const [form, setForm] = useState({});
  const [data, setData] = useState({});
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // const {
  //   form = {},
  //   data = {},
  //   progress,
  // } = formData['cadd-kyc'] || {};

  useEffect(() => {
    setForm({});
    setData({});
    setIsLoading(true);
    ProjectKYCGet(id, userId, { namespace, module, view });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, userId]);

  useEffect(() => {
    if (formData && formData.form) {
      setIsLoading(false);
      setForm({ ...formData.form })
      if (formData.data) {
        setData({ ...formData.data })
      }
      if (formData.progress) {
        setProgress(formData.progress);
      }
    }
  }, [formData, formData.form])
  return !isLoading && Object.keys(formData).length > 0 && Object.keys(data).length === 0 ? <NotFound /> : <Styles className="semibold form-input-output" style={{ height: '100%' }}>
    <PageHeader
      title={t("KYC Report")}
      onBack={() => goTo(`/app/cadd/project/${id}`)}
      extra={[
        <div>
          {data && data.name ? <Tag>{data.name}</Tag> : null}
        </div>,
        <div style={{ fontSize: '12px' }}>
          {data && data.updatedAt ? <> Last Update: {moment(data.updatedAt).format('DD MMM YYYY')} </> : null}
        </div>,
        <Progress
          key="2"
          style={{ width: "300px", lineHeight: "30px" }}
          type="line"
          showInfo={true}
          percent={progress}
          strokeColor={getProgressColor(progress)}
        />,
        <div
          key="3"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <p style={{ margin: '0 12px 0 0' }}><strong>{t("View")}:</strong></p>
          <Switch
            checkedChildren={t("Sections")}
            unCheckedChildren={t("Full")}
            checked={isTabsView}
            onChange={(checked) => {
              if (checked) {
                StorageManager.set('datastake-view-mode', 'section');
              } else {
                StorageManager.set('datastake-view-mode', 'full');
              }
              setTabsView(checked)
            }}
            className="view-toggle"
          />
        </div>
      ]} />
    {form ? <DynamicView
      setEditVisible={(ind) => { }}
      onTabChange={(ind) => { }}
      tabs={isTabsView}
      form={form}
      data={data}>
    </DynamicView> : null}
  </Styles>
}


export default connect(mstp, actions)(KYC);
